import { useContext } from "react";

import DataContext from "../../../../../../context/DataContext";
import renderAvailablePages from "../utils/renderAvailablePages";
import { STRINGS } from "../utils/strings";

import CustomNavChip from "./CustomNavChip";

const OtherPagesDashFilter = () => {
  const { userRoles, loggedInUser } = useContext(DataContext);

  const renderOtherPagesCardContent = () => {
    return renderAvailablePages(userRoles, loggedInUser).map((dataValue) => (
      <CustomNavChip
        path={dataValue.path}
        title={dataValue.title}
        color={dataValue.color}
        key={dataValue.path}
        active={dataValue.active}
      />
    ));
  };

  const availablePages = renderOtherPagesCardContent();

  return (
    <div
      id="Other-Pages-Dashboard-Filter"
      data_testid="Other-Pages-Dashboard-Filter"
      className="overflow-y-auto"
    >
      <div className="flex flex-col gap-2" style={{ padding: "0 15px" }}>
        {availablePages.length === 0 ? (
          <div className="flex flex-col justify-center h-full">
            <h2 className="my-4 text-center text-[1.2rem] font-bold">
              {STRINGS.NO_AVAILABLE_PAGES}
            </h2>
          </div>
        ) : (
          availablePages
        )}
      </div>
    </div>
  );
};

export default OtherPagesDashFilter;
